<!--Start: Nav  -->
<div class="ui fixed borderless huge menu">

    <div class="ui container grid">

        <!--Start: Desktop Nav-->
        <div class="row">
            @if (siteParams && siteParams.BannerUrl) {
            <div class="item banner"><img [src]="siteParams.BannerUrl" alt="Banner" /></div>
            }
            <a [routerLink]="'/dashboard'" class="header item">Compliance Portal</a>
            <a [routerLink]="'/dashboard'" class=" item" translate>Welcome &nbsp; @if (userData) {
                <span>{{userData.firstName}}!</span>
                }</a>


            <div class="right menu">


                <a class="ui dropdown item">
                    <span>{{currentLang | translate}}</span>
                    <div class="menu" id="languages">
                        @for (l of langs; track l) {
                        <div class="item">
                            <a href="#" (click)="changeLanguage(l.id)" translate>{{l.name}}</a>
                        </div>
                        }

                    </div>
                </a>
                <a class="item" (click)="logout()" translate>Logout</a>

            </div>
        </div>
        <!--End: Desktop Nav-->

    </div>
</div>
<!--End: Nav  -->
<div class="ui container bodycontainer">

    <router-outlet></router-outlet>
    <p class="version">v.{{ version }}</p>
</div>